<div class="p-2">
  <div class="row-no-margin">
    <span class="popup-header">Item Search</span>
  </div>
  <div class="row-no-margin">
    <!--search bar-->
    <div class="col-md-4">

      <!--<input type="text" placeholder="Item" [(ngModel)]="ItemNumberSearch.Value" (keyup)="LoadItems()" />-->
    </div>
    <div class="col-md-4">

      <!--<input type="text" placeholder="Description" [(ngModel)]="DescSearch.Value" (keyup)="LoadItems()" />-->
    </div>
  </div>
  <div class="row-no-margin">
    <!--results-->
    <table style="width:100%;">
      <tr>
        <th><input type="text" placeholder="Item" [(ngModel)]="ItemNumberSearch.Value" (keyup)="LoadItems()" /></th>
        <th><input type="text" placeholder="Description" [(ngModel)]="DescSearch.Value" (keyup)="LoadItems()" /></th>
        <th><span class="clickable" (click)="AdvancedSearch = !AdvancedSearch">{{AdvancedSearch ? "HIDE ADVANCED" : "ADVANCED"}}</span></th>
      </tr>
      <ng-container *ngIf="AdvancedSearch">
        <tr>
          <th><input type="text" placeholder="Job" [(ngModel)]="JobNumberSearch.Value" /></th>
          <th><input type="text" placeholder="Serial#" [(ngModel)]="SerialNumberSearch.Value" /></th>
          <th><button class="blue" (click)="AdvancedSearch_Click()">Search</button></th>
        </tr>

      </ng-container>
      <ng-container *ngFor="let item of ItemList">
        <tr>
          <td><span (click)="SelectItem(item)" class="clickable blue-color" style="padding-left:5px;">{{item.Item}}</span></td>
          <td colspan="2">{{item.Description}}</td>
        </tr>
      </ng-container>
    </table>
    <mat-paginator [length]="ItemCount" style="width:100%;" [pageIndex]="PageIndex" [pageSize]="PageSize" [pageSizeOptions]="PageSizeOptions" (page)="PageEvent($event)">
    </mat-paginator>
  </div>
  <div class="row-no-margin justify-content-center">
    <!--buttons-->
    <button class="blue" (click)="CloseSearch()">Close</button>
  </div>
  <div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
    <div style="position: absolute; top: 45%; left: 45%;">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  </div>

</div>
